import React, { useMemo } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import DataTable from "react-data-table-component";
import moment from "moment";
import { longDateString } from "../../utils";
import "../../starek.css";

function JobSchedulesListingView({
    items,
    selectedRows,
    onSelectedRowsChange,
    filterText,
    toggleCleared,
    noDataComponent,
    onRowClicked,
}) {
    const filteredItems = useMemo(() => {
        const q = filterText?.trim().toLowerCase();
        if (!q) return items;
        return items.filter(
            (item) =>
                String(item.name || "")
                    .toLowerCase()
                    .includes(q) ||
                String(item.description || "")
                    .toLowerCase()
                    .includes(q) ||
                String(item.part?.name || "")
                    .toLowerCase()
                    .includes(q) ||
                String(item.cycle?.name || "")
                    .toLowerCase()
                    .includes(q) ||
                String(item.device_id || "")
                    .toLowerCase()
                    .includes(q)
        );
    }, [items, filterText]);

    const columns = [
        {
            name: "Name",
            selector: (r) => r.name || "-",
            sortable: true,
            height: "50px",
            grow: 1.2,
        },
        {
            name: "Part",
            selector: (r) => r.part?.name || "-",
            sortable: true,
            height: "50px",
            width: "150px",
        },
        {
            name: "Cycle",
            selector: (r) => r.cycle?.name || "-",
            sortable: true,
            height: "50px",
            width: "150px",
        },
        {
            name: "Device",
            selector: (r) => r.device_id || "-",
            sortable: true,
            height: "50px",
            width: "120px",
        },
        {
            name: "Start Time",
            selector: (r) =>
                r.start_time ? moment(r.start_time).format("lll") : "-",
            sortable: true,
            height: "50px",
            width: "180px",
        },
        {
            name: "End Time",
            selector: (r) =>
                r.end_time ? moment(r.end_time).format("lll") : "-",
            sortable: true,
            height: "50px",
            grow: 1,
        },
        {
            name: "Activity",
            selector: (r) => r.updated_at,
            sortable: true,
            height: "50px",
            width: "250px",
            cell: (r) => {
                const tooltipText = `Created by ${
                    r.created_by?.name || "Unknown"
                } at ${
                    r.created_at ? longDateString(r.created_at) : "-"
                }\nModified by ${r.updated_by?.name || "Unknown"} at ${
                    r.updated_at ? longDateString(r.updated_at) : "-"
                }`;
                return (
                    <div style={{ fontSize: "0.85rem" }} title={tooltipText}>
                        {r.updated_by?.name || "Unknown"} at{" "}
                        {r.updated_at ? longDateString(r.updated_at) : "-"}
                    </div>
                );
            },
        },
    ];

    return (
        <DataTable
            columns={columns}
            data={filteredItems}
            selectableRows
            onSelectedRowsChange={onSelectedRowsChange}
            clearSelectedRows={toggleCleared}
            highlightOnHover
            striped
            pointerOnHover
            onRowClicked={(row) => onRowClicked?.(row)}
            responsive
            pagination
            dense
            selectableRowsHighlight
            selectableRowsNoSelectAll={false}
            noDataComponent={noDataComponent}
        />
    );
}

export default JobSchedulesListingView;
